import {useTranslation} from "ni18n";
import React from "react";
import {V5Img} from "src/components/_common/Carbon";

import SectionHeader from "./SectionHeader";

type Props = {
  hideStory?: boolean;
};

const AboutUs: React.FC<Props> = ({hideStory}) => {
  const i18n = useTranslation();

  const data = [
    !hideStory && {
      tag: i18n.t("Founded in 2015"),
      header: i18n.t("Our story"),
      paragraphs: [
        i18n.t(
          "Combining smart technology with modern, welcoming clinics, Carbon Health delivers a uniquely seamless experience — with virtual and in-person appointments, primary care, urgent care, and mental healthcare — to meet you where you are. We aim to make the exceptional expected.",
        ),
        i18n.t(
          "We’re removing traditional boundaries in healthcare, to make high-quality, transparent, and personal care accessible — because great care should always be within reach, no matter who or where you are.",
        ),
      ],
    },
    {
      tag: i18n.t("What we believe"),
      header: i18n.t("Our culture"),
      paragraphs: [
        i18n.t(
          "At Carbon Health, we believe in the power of health, of medicine, and of technology. We aim to create a supportive environment where you can develop your career and continually refine your craft, whether you work in one of our clinics or with the team at Carbon Health headquarters.",
        ),
        i18n.t(
          "We hire people who genuinely care. In doing so, we’ve built a diverse and passionate team of employees who are all driven to learn from one another and support Carbon Health’s mission of bringing high-quality healthcare to everyone.",
        ),
      ],
    },
  ].compact();

  return (
    <div className="ph8 pt30 pt12-sm pb10 pos-r">
      <V5Img
        className="pos-a right0 h140 dn-md"
        style={{bottom: -30}}
        src="/illustrations/squiggly-lines"
      />
      <div className="maxw80 ma">
        {data.map((section, i) => (
          <div key={section.tag} className={`df fdc mb${i === data.length - 1 ? "20" : "30"}`}>
            <SectionHeader tag={section.tag} header={section.header} />
            <div className="df fdc-sm font-cm font-ir-sm jcsb maxw70 fs20 mt16 fs16-xs">
              {section.paragraphs.map(p => (
                <p key={p.slice(0, 10)} className="fx maxw28 mr10 mr0-sm mb10 mb5-xs">
                  {p}
                </p>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AboutUs;
